var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconReply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 15 11.59"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.62 2.21V.86A.86.86 0 0 0 4.16.25L.25 4.16a.86.86 0 0 0 0 1.21l3.91 3.91a.85.85 0 0 0 1.46-.6V7.24c4.26 0 7.25 1.37 9.38 4.35-.85-4.26-3.41-8.53-9.38-9.38",
  className: "icon-reply_svg__cls-1"
})));
export default SvgIconReply;